import { TenantEntity } from '../TenantEntity'

export class SurchargeTerms extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get chargeItemId() {
    return this._data.chargeItemId
  }
  set chargeItemId(chargeItemId) {
    this._data.chargeItemId = chargeItemId || 0
  }
  get terms() {
    return this._data.terms
  }
  set terms(terms) {
    this._data.terms = terms
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
}
